var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.87v17.608c0 2.87 2.348 5.218 5.217 5.218h19.566c2.87 0 5.217-2.348 5.217-5.218V12.826H7.087C5.913 12.826 5 11.913 5 10.804c0-1.043.783-1.956 1.826-2.021l25.565-2.479v6.522",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.708 18.333H35v8.334h-7.292c-2.406 0-4.375-1.875-4.375-4.167s1.969-4.167 4.375-4.167z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 24.167a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334z",
    fill: "#fff"
  })));
}

var MemoSvgWallet = /*#__PURE__*/React.memo(SvgWallet);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTAuODY5N1YyOC40Nzg0QzUgMzEuMzQ3OSA3LjM0NzgzIDMzLjY5NTcgMTAuMjE3NCAzMy42OTU3SDI5Ljc4MjZDMzIuNjUyMiAzMy42OTU3IDM1IDMxLjM0NzkgMzUgMjguNDc4NFYxMi44MjYySDcuMDg2OTZDNS45MTMwNCAxMi44MjYyIDUgMTEuOTEzMSA1IDEwLjgwNDRDNSA5Ljc2MDk2IDUuNzgyNjEgOC44NDc5MiA2LjgyNjA5IDguNzgyN0wzMi4zOTEzIDYuMzA0NDRWMTIuODI2MiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy43MDggMTguMzMzM0gzNC45OTk3VjI2LjY2NjZIMjcuNzA4QzI1LjMwMTggMjYuNjY2NiAyMy4zMzMgMjQuNzkxNiAyMy4zMzMgMjIuNDk5OUMyMy4zMzMgMjAuMjA4MyAyNS4zMDE4IDE4LjMzMzMgMjcuNzA4IDE4LjMzMzNaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI3LjQ5OTcgMjQuMTY2NkMyOC40MjAyIDI0LjE2NjYgMjkuMTY2MyAyMy40MjA0IDI5LjE2NjMgMjIuNDk5OUMyOS4xNjYzIDIxLjU3OTQgMjguNDIwMiAyMC44MzMzIDI3LjQ5OTcgMjAuODMzM0MyNi41NzkyIDIwLjgzMzMgMjUuODMzIDIxLjU3OTQgMjUuODMzIDIyLjQ5OTlDMjUuODMzIDIzLjQyMDQgMjYuNTc5MiAyNC4xNjY2IDI3LjQ5OTcgMjQuMTY2NloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { MemoSvgWallet as ReactComponent };